// SPDX-License-Identifier: Apache-2.0

// add new version of fabric here
const FabricVersion = ['v2.5', 'v2.4', 'v2.2'];

export default FabricVersion;
